<template>
  <custom-dialog
    :openDialog="isOpen"
    :widthDialog="'800px'"
    :classDialog="'create-dialog custome-dialog'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <!--    <template #header>-->
    <!--      <h3 class="dialogTitle">Tìm kiếm nâng cao</h3>-->
    <!--    </template>-->

    <template #header>
      <h5 class="dialogTitle margin-left-10">
        Tìm kiếm nâng cao
      </h5>
    </template>

    <template #body>
      <el-form
        :model="advanceSearchForm"
        ref="form"
        label-position="left"
        label-width="150px"
      >
        <!-- Trường cũ Cuộc họp -->
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Tên QC/QĐ/QT" class="formItem">
              <el-input
                class="style-fullWidth input-border__bottom input-border__radius__0"
                v-model="advanceSearchForm.meeting"
                size="medium"
                placeholder="Tên Quy chế /Quy định /Quy trình "
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

       <!-- Trường cũ (Đơn vị thực hiện) -->
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Đơn vị chủ trì" class="formItem">
              <el-select
                clearable
                filterable
                v-model="advanceSearchForm.deptId"
                size="medium"
                placeholder="Đơn vị chủ trì"
                class="style-fullWidth input-border__bottom input-border__radius__0"
              >
                <el-option
                  v-for="item in listDept"
                  :key="item.id"
                  :label="item.deptName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="16">
            <el-form-item label="Ngày chỉ đạo" class="formItem">
              <el-date-picker
                v-model="commandTimeRange"
                type="daterange"
                format="dd/MM/yyyy"
                class="style-fullWidth input-border__bottom input-border__radius__0"
                :picker-options="dateQuickFilterOption"
                range-separator="_"
                start-placeholder="_"
                end-placeholder="_"
                align="right"
                @change="commandTimeRangeChanged"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col>
            <el-form-item label="Lãnh đạo phụ trách" class="formItem">
              <el-select
                class="style-fullWidth input-border__bottom input-border__radius__0"
                v-model="advanceSearchForm.performIds"
                placeholder="Lãnh đạo phụ trách"
                size="medium"
                filterable
                clearable
                multiple
              >
                <el-option
                  v-for="item in listDirectives"
                  :key="item.id"
                  :label="`${item.fullName} - ${item.positionName}`"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="16">
            <el-form-item label="Hạn hoàn thành" class="formItem">
              <el-date-picker
                v-model="deadlineRange"
                type="daterange"
                format="dd/MM/yyyy"
                class="style-fullWidth input-border__bottom input-border__radius__0"
                :picker-options="dateQuickFilterOption"
                range-separator="_"
                start-placeholder="_"
                end-placeholder="_"
                align="right"
                @change="deadlineRangeChanged"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="16">
            <el-form-item label="Trạng thái" class="formItem">
              <el-select
                clearable
                filterable
                v-model="advanceSearchForm.state"
                size="medium"
                placeholder="Trạng thái"
                class="style-fullWidth input-border__bottom input-border__radius__0"
              >
                <el-option
                  v-for="item in listStates"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- Trường cũ Nội dung -->
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Ghi chú" class="formItem">
              <el-input
                class="style-fullWidth input-border__bottom input-border__radius__0"
                v-model="advanceSearchForm.note"
                size="medium"
                placeholder="Ghi chú"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>

    <template #footer>
      <div class="flex-row flex__right form-button__action">
        <el-button class="dialogBtnPrimary" @click="search">
          <i class="fal fa-search font-size__small"></i>
          &nbsp;Tìm kiếm
        </el-button>
        <el-button class="btn__cancel btn-none__border" @click="reset"
          >Xóa
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>

<script>
import hanhchinhService from "../../../services/hanhchinhService";
import h from "../../../services/h";
import CustomDialog from "../../common/custom-dialog";
import hanhChinhUtils from "../../../services/hanhChinhUtils";
import constants from "../../../constants";
import utils from "../../../services/utils";
import userDeptRoleViewService from "../../../services/userDeptRoleViewService";
import hcFlowService from "../../../services/hcFlowService";

export default {
  name: "hc-command-advance-search-dialog",
  props: ["isOpen", "form"],
  components: {
    CustomDialog
  },

  computed: {
    parentDeptId() {
      let userDeptRole = h.find(
        this.$store.state.userDeptRoles,
        userDeptRole => userDeptRole.id === this.$store.getters.userDeptRoleId
      );
      return userDeptRole.parentDeptId;
    }
  },

  data() {
    return {
      sectors: [],
      listDept: [],
      listProgress: [],
      listStatus: [],
      listStates: [],

      commandTimeRange: null,
      deadlineRange: null,
      finishTimeRange: null,
      listDirectives: null,
      hcFlow: null,

      advanceSearchForm: {
        meeting: null,
        sector: null,
        deptId: null,
        progress: null,
        commandsStatus: null,
        state: null,
        conclusion: null,
        note: null,
        startTimeCommand: null,
        endTimeCommand: null,
        startTimeDeadline: null,
        endTimeDeadline: null,
        startTimeFinish: null,
        endTimeFinish: null,
        directiveIds: null,
        performIds: null
      },

      dateQuickFilterOption: utils.getDefaultDateQuickFilterOption()
    };
  },

  async created() {
    this.initSelectOptions();
    this.loadDepartments();
    await this.loadHcFlow();
    await this.loadDirectiveActors();
    this.initForm();
  },

  methods: {
    commandTimeRangeChanged() {
      utils.timeRangeChanged(this.commandTimeRange, (from, to) => {
        this.advanceSearchForm.startTimeCommand = from;
        this.advanceSearchForm.endTimeCommand = to;
      });
    },

    deadlineRangeChanged() {
      utils.timeRangeChanged(this.deadlineRange, (from, to) => {
        this.advanceSearchForm.startTimeDeadline = from;
        this.advanceSearchForm.endTimeDeadline = to;
      });
    },

    finishTimeRangeChanged() {
      utils.timeRangeChanged(this.finishTimeRange, (from, to) => {
        this.advanceSearchForm.startTimeFinish = from;
        this.advanceSearchForm.endTimeFinish = to;
      });
    },

    initForm() {
      this.advanceSearchForm.meeting = this.form.meeting;
      this.advanceSearchForm.sector = this.form.sector;
      this.advanceSearchForm.deptId = this.form.deptId;
      this.advanceSearchForm.progress = this.form.progress;
      this.advanceSearchForm.commandsStatus = this.form.commandsStatus;
      this.advanceSearchForm.state = this.form.state;
      this.advanceSearchForm.conclusion = this.form.conclusion;
      this.advanceSearchForm.note = this.form.note;
      this.advanceSearchForm.startTimeCommand = this.form.startTimeCommand;
      this.advanceSearchForm.endTimeCommand = this.form.endTimeCommand;
      this.advanceSearchForm.startTimeDeadline = this.form.startTimeDeadline;
      this.advanceSearchForm.endTimeDeadline = this.form.endTimeDeadline;
      this.advanceSearchForm.startTimeFinish = this.form.startTimeFinish;
      this.advanceSearchForm.endTimeFinish = this.form.endTimeFinish;
      this.advanceSearchForm.directiveIds = this.form.directiveIds;
      this.advanceSearchForm.performIds = this.form.performIds;

      this.initCommandTimeRange();
      this.initDeadlineRange();
      this.initFinishTimeRange();
    },

    initCommandTimeRange() {
      this.commandTimeRange = utils.initTimeRange(
        this.advanceSearchForm.startTimeCommand,
        this.advanceSearchForm.endTimeCommand
      );
    },

    initDeadlineRange() {
      this.deadlineRange = utils.initTimeRange(
        this.advanceSearchForm.startTimeDeadline,
        this.advanceSearchForm.endTimeDeadline
      );
    },

    initFinishTimeRange() {
      this.finishTimeRange = utils.initTimeRange(
        this.advanceSearchForm.startTimeFinish,
        this.advanceSearchForm.endTimeFinish
      );
    },

    initSelectOptions() {
      hanhChinhUtils
        .buildHcCommandSectorOptions()
        .then(sectors => (this.sectors = sectors));

      this.listProgress = h.collect(
        [
          constants.HC_CASE_COMMANDS.PROGRESS.ON_TIME,
          constants.HC_CASE_COMMANDS.PROGRESS.LATE
        ],
        progress => {
          return {
            id: progress,
            name: hanhChinhUtils.getHcCommandProgressName(progress)
          };
        }
      );

      this.listStatus = hanhChinhUtils.buildHcCommandStatusOptions();

      this.listStates = h.collect(
        [
          constants.HC_STATE.STATE_CODE.CHI_DAO.DANG_THUC_HIEN,
          constants.HC_STATE.STATE_CODE.CHI_DAO.CHO_PHE_DUYET_HOAN_THANH,
          constants.HC_STATE.STATE_CODE.CHI_DAO.HOAN_THANH,
          constants.HC_STATE.STATE_CODE.CHI_DAO.HUY_CHI_DAO
        ],
        status => {
          return {
            id: status,
            name: hanhChinhUtils.getHcCommandStateName(status)
          };
        }
      );
    },

    search() {
      let advanceSearchForm = {
        meeting: utils.nvl(this.advanceSearchForm.meeting, undefined),
        sector: utils.nvl(this.advanceSearchForm.sector, undefined),
        deptId: utils.nvl(this.advanceSearchForm.deptId, undefined),
        progress: utils.nvl(this.advanceSearchForm.progress, undefined),
        commandsStatus: utils.nvl(
          this.advanceSearchForm.commandsStatus,
          undefined
        ),
        state: utils.nvl(this.advanceSearchForm.state, undefined),
        conclusion: utils.nvl(this.advanceSearchForm.conclusion, undefined),
        note: utils.nvl(this.advanceSearchForm.note, undefined),
        startTimeCommand: utils.nvl(
          this.advanceSearchForm.startTimeCommand,
          undefined
        ),
        endTimeCommand: utils.nvl(
          this.advanceSearchForm.endTimeCommand,
          undefined
        ),
        startTimeDeadline: utils.nvl(
          this.advanceSearchForm.startTimeDeadline,
          undefined
        ),
        endTimeDeadline: utils.nvl(
          this.advanceSearchForm.endTimeDeadline,
          undefined
        ),
        startTimeFinish: utils.nvl(
          this.advanceSearchForm.startTimeFinish,
          undefined
        ),
        endTimeFinish: utils.nvl(
          this.advanceSearchForm.endTimeFinish,
          undefined
        ),
        directiveIds: utils.nvl(
          this.advanceSearchForm.directiveIds,
          undefined
        ),
        performIds: utils.nvl(
          this.advanceSearchForm.performIds,
          undefined
        )
      };
      this.$emit("doSearch", { advanceSearchForm: advanceSearchForm });
      this.$emit("closeDialog");
    },

    reset() {
      this.advanceSearchForm.meeting = null;
      this.advanceSearchForm.sector = null;
      this.advanceSearchForm.deptId = null;
      this.advanceSearchForm.progress = null;
      this.advanceSearchForm.commandsStatus = null;
      this.advanceSearchForm.state = null;
      this.advanceSearchForm.conclusion = null;
      this.advanceSearchForm.note = null;
      this.advanceSearchForm.startTimeCommand = null;
      this.advanceSearchForm.endTimeCommand = null;
      this.advanceSearchForm.startTimeDeadline = null;
      this.advanceSearchForm.endTimeDeadline = null;
      this.advanceSearchForm.startTimeFinish = null;
      this.advanceSearchForm.endTimeFinish = null;
      this.advanceSearchForm.directiveIds = null;
      this.advanceSearchForm.performIds = null;
      this.initCommandTimeRange();
      this.initDeadlineRange();
      this.initFinishTimeRange();
    },

    loadDepartments() {
      return hanhchinhService.getDept(this.parentDeptId).then(response => {
        this.listDept = (response.data.departments || []).sort((dept1, dept2) =>
          dept1.deptName.localeCompare(dept2.deptName)
        );
      });
    },

    loadHcFlow() {
      return hcFlowService
        .getHcFlowAlternativeForHcCommands2()
        .then(response => (this.hcFlow = response.data));
    },

    loadDirectiveActors() {
      return userDeptRoleViewService
        .findAllForHcCommands(this.hcFlow.deptId)
        .then(response => (this.listDirectives = response.data));
    },
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/quychequydinh/hc-quychequydinh-advance-search-dialog.vue